import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as SchedulesActionVaillant from './schedules.action';
import { switchMap, catchError, take, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { SchedulesFacadeVaillant } from './schedules.facade';
import { EventSchedule } from './schedules.interface';
import { CreateNewSchedule } from '@library/store/schedules/schedules.action';
import { SchedulesService } from '@library/store/schedules/schedules.service';


@Injectable()
export class SchedulesEffectsVaillant {
  constructor(
    private schedulesService: SchedulesService,
    private actions$: Actions,
    private schedulesFacade: SchedulesFacadeVaillant
  ) { }

  createNewScheduleVaillant$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SchedulesActionVaillant.CreateNewScheduleVaillant>
        (SchedulesActionVaillant.EnumSchedulesActionsVaillant.CreateNewScheduleVaillant),
      switchMap((action) => {
        return this.schedulesService.createNewSchedule(action.payload).pipe(
          map((response) => response),
          switchMap((response: any) => {
            /* Create the corresponding event schedule and link it to the 'therm' schedule using response.body.schedule_id
             that we put in the 'schedule_hwb_associated_vaillant' property of the event schedule */
            let scheduleAction: EventSchedule;
            this.schedulesFacade.createEventZones(action.payload.timetable, action.payload.name, response.body.schedule_id).subscribe(
              (val: EventSchedule) => scheduleAction = val);
            return [
              new SchedulesActionVaillant.CreateNewScheduleVaillantSuccess({
                schedule_id: response.body.schedule_id, schedule_info: action.payload
              }),
              new CreateNewSchedule({ ...scheduleAction })
            ];
          }),
          catchError(({ error }) => of(new SchedulesActionVaillant.CreateNewScheduleVaillantFailure(error))),
        );
      })
    )
  );
}
